// How hard the server screens chat messages, mirrored from the backend's toxicCheckLevel.
// A chat is screened at the highest level among its participants.
export const TOXIC_CHECK_LEVEL = {
  NORMAL: 0,
  STRICT: 1,
  VERY_STRICT: 2,
};

// Servers that predate toxicCheckLevel only send strictToxicCheck, which is true from level 1.
export function toxicCheckLevelOf(data: {toxicCheckLevel?: unknown; strictToxicCheck?: unknown}): number {
  const level = data.toxicCheckLevel;
  if (level === TOXIC_CHECK_LEVEL.NORMAL || level === TOXIC_CHECK_LEVEL.STRICT || level === TOXIC_CHECK_LEVEL.VERY_STRICT) {
    return level;
  }
  return data.strictToxicCheck === true ? TOXIC_CHECK_LEVEL.STRICT : TOXIC_CHECK_LEVEL.NORMAL;
}



// WEBPACK FOOTER //
// ./src/services/user/toxicCheckLevel.ts